
import { Component, Vue } from "vue-property-decorator";
import CandidateV3Custom, {
  CandidateV3Item
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3";
import Auth from "@/lib/common/auth";
import CandidateSelect from "@/views/exam-v3/components/candidate-select.vue";
import CandidateCreateForm from "@/lib/form/candidate/CandidateCreateForm";
import {
  CandidateMCreateParams,
  CandidateMCreateParseParams
} from "@/lib/model/exam/candidate";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import Template from "@/views/ai-builder/components/template.vue";
import h5Dialog from "./component/dialog.vue";
import { CompanyConfig } from "@/lib/common/acm";
import Decrypt from "@/lib/model/decryptParams/decryptParams";

interface ExamItem {
  id: number;
  name: string;
  remark: string;
  isEnableAi: boolean;
  examTypeFlag: boolean;
  examId?: number;
}

enum SubmitStatus {
  "未登记" = 0,
  "答题中" = 1,
  "已交卷" = 2,
  "已登记" = 3,
  "已交卷未评分" = 4
}
enum MarkStatus {
  "未评价" = 0,
  "通过" = 1,
  "待定" = 2,
  "拒绝" = 3
}

@Component({
  components: {
    Template,
    CandidateSelect,
    h5Dialog
  }
})
export default class CandidateListV3 extends Vue {
  defaultPhoto = require("@/assets/head-logo-long.png");
  onerror(item: any) {
    item.photoUrl = "";
  }
  dialogInfo = {
    loading: {
      isLoading: true,
      text: "加载中..."
    }
  };
  dialogType = "loading";
  // 筛选相关
  examList: ExamItem[] = [];
  searchKeyLike = "";
  searchForm = new CandidateListForm().assign({
    companyId: Number(Auth.companyId),
    examType: "aibuilder",
    sortKey: "",
    sortDict: "",
    asCompany: 1,
    searchKeyLike: "",
    showNameOrPhone: ""
  });

  // 列表数据
  loadingList = false;
  data: CandidateV3Item[] = [];
  total = 0;
  firstInit = true; //第一次进来
  //枚举
  SubmitStatus = SubmitStatus;
  MarkStatus = MarkStatus;

  //   // 获取全部面试
  //   async getExamAll() {
  //     const params = new ExamGetAllForm();
  //     params.companyId = Number(Auth.companyId);
  //     const res = await ExamList.examGetAll(params);
  //     res.list.forEach((examRes: any) => {
  //       this.examList.push({
  //         id: examRes.examId,
  //         name: examRes.name,
  //         remark: examRes.remark,
  //         isEnableAi: examRes.companySpecialConfig?.isEnableAi === 1,
  //         examTypeFlag: examRes.examType !== "test"
  //       });
  //     });
  //   }
  backing = false;
  back() {
    if (this.backing) return;
    this.backing = true;
    this.$router.go(-1);
  }
  statusColor(status: number) {
    if (status === 1) {
      return "#00BD82";
    } else if (status === 2) {
      return "#01ADFF";
    } else if (status === 3) {
      return "#E63A0E";
    } else {
      return "#111111";
    }
  }
  async toReport(row: CandidateV3Item) {
    let url = `/h5-report?connectCode=${row.connectCode}&companyId=${
      Auth.companyId
    }${row.subExamId ? "&subExamId=" + row.subExamId : ""}`;
    try {
      //获取报告鉴权tid
      await Decrypt.get({
        candidateId: String(row.candidateId)
      }).then(res => {
        url += "&tid=" + res.tid;
        this.$router.push(url);
      });
    } catch (e) {
      this.$message.warning("网络不佳，请稍后再试");
      console.log(e);
    }
  }
  async toMark(row: CandidateV3Item) {
    //
    let url = `/h5-mark?connectCode=${row.connectCode}&companyId=${
      Auth.companyId
    }${row.subExamId ? "&subExamId=" + row.subExamId : ""}`;
    try {
      //获取报告鉴权tid
      await Decrypt.get({
        candidateId: String(row.candidateId)
      }).then(res => {
        url += "&tid=" + res.tid;
        this.$router.push(url);
      });
    } catch (e) {
      this.$message.warning("网络不佳，请稍后再试");
      console.log(e);
    }
  }

  mounted() {
    setTimeout(() => {
      (this.$refs.searchInputReal as any).focus();
    }, 300);
  }
  search() {
    //
    this.firstInit = false;
    this.getCandidateList();
  }

  get fuzzySearch() {
    return CompanyConfig.getInstance().fuzzySearch === 1;
  }

  // 获取面试候选人列表
  async getCandidateList() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.loadingList = true;

    if (this.fuzzySearch) {
      this.searchForm.searchKeyLike = this.searchKeyLike;
    } else {
      this.searchForm.showNameOrPhone = this.searchKeyLike;
    }

    const res = await CandidateV3Custom.get(this.searchForm);
    this.data = res.list;
    this.total = res.count;
    this.loadingList = false;
  }

  // 面试详情展示字段
  echarsData: number[] = [];
  examAll = 0;
  examNotSignIn = 0;
  examSignIn = 0;
  examAnswering = 0;
  examFinishAll = 0;

  headerLoading = false;

  activeExamItem: any = {
    examId: "",
    name: ""
  };
  examChange(examItem: any) {
    this.searchForm.examId = examItem.examId;
    this.activeExamItem = examItem;
    this.searchForm.page = 1;
    this.getCandidateList();
    (this.$refs.tableRef as any).handleClearSelected();
  }

  examSubmitStatusChange(value: number) {
    if (value === -1) {
      this.searchForm.submitStatusList = [];
    } else {
      this.searchForm.submitStatusList = [value];
    }
    this.searchForm.page = 1;
    this.getCandidateList();
  }
  async created() {
    // await this.getCandidateList();
  }

  showExamLink = false;
  scanLink = "";
  scanUrl = "";

  addCandidate = false;
  candidateCreateForm = new CandidateCreateForm();

  isShowAddMore = false;
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();
  examGetForm = new ExamGetForm();
}
